import { SerieSettingEntity } from '../apis/serie/serie-setting-entity';
import { TeamSettingEntity } from '../apis/team/team-setting-entity';
import { SchedulerSetting } from '../components/scheduler/scheduler-setting';
import { Penalty } from './penalty';
import { CustomIntervalEntity } from '../apis/custom-interval/custom-interval-entity';
import { SchedulerResponseEntity } from '../apis/scheduler/scheduler-response-entity';
import { ScheduleEntity } from '../apis/schedule/schedule-entity';
import { ScheduleRowCollection } from './schedule-row-collection';
import { ScheduleRowEntity } from '../apis/schedule/schedule-row-entity';

export class SchedulerModel {

    public schedulerSetting: SchedulerSetting = new SchedulerSetting();
    public scheduleRowCollections: ScheduleRowCollection[] = [];
    public serie: SerieSettingEntity = null;
    public teamSettings: TeamSettingEntity[] = [];
    public hasBreakingChanges: boolean = false;
    public customIntervals: CustomIntervalEntity[] = [];
    private _selectedScheduleRowCollection: ScheduleRowCollection = null;
    private _scheduleEntity: ScheduleEntity = new ScheduleEntity();

    // private _schedulesApi: ScheduleApi;
    // private _scheduleRowsApi: ScheduleRowApi;
    // private _serieApi: SerieApi;
    // private _teamApi: TeamApi;
    // private _customIntervalApi: CustomIntervalApi;

    constructor(scheduleEntity: ScheduleEntity, serie: SerieSettingEntity, teamSettings: TeamSettingEntity[], customIntervals: CustomIntervalEntity[], games: ScheduleRowEntity[]) {
        this._scheduleEntity = scheduleEntity;
        this.serie = serie;
        this.teamSettings = teamSettings;
        this.customIntervals = customIntervals;
        this.scheduleRowCollections = [];
        if (games && games.length > 0) {
            const collection = new ScheduleRowCollection();
            collection.updateGames(games);
            collection.selected = true;
            collection.isSaved = true;
            this.scheduleRowCollections.push(collection);
            this._selectedScheduleRowCollection = collection;
        }
    }

    public get scheduleId(): string {
        return this._scheduleEntity.id;
    }
    public get name(): string {
        return this._scheduleEntity.name;
    }
    public set name(value: string) {
        this._scheduleEntity.name = value;
    }
    public get eventId(): string {
        return this._scheduleEntity.eventId;
    }
    public get groupIds(): string[] {
        return this._scheduleEntity.groupIds;
    }
    public set groupIds(value: string[]) {
        this._scheduleEntity.groupIds = value ?? [];
    }

    public get startDayOffset(): number {
        return this._scheduleEntity.startDayOffset;
    }
    public set startDayOffset(value: number) {
        this._scheduleEntity.startDayOffset = value;
    }
    public get isNew(): boolean {
        return this._scheduleEntity.code == null;
    }

    public get games(): ScheduleRowEntity[] {
        return this._selectedScheduleRowCollection == null ?  [] : this._selectedScheduleRowCollection .games;
    }

    public get selectedScheduleRowCollection(): ScheduleRowCollection {
        return this._selectedScheduleRowCollection;
    }
    public reset(): void {
        this.serie = new SerieSettingEntity();
        this.schedulerSetting = new SchedulerSetting();
        this._scheduleEntity = new ScheduleEntity();
        this.teamSettings.clear();
        this.scheduleRowCollections.clear();
        this._selectedScheduleRowCollection = null;
    }

    public selectScheduleRowCollection(index: number): void {
        for (let i = 0; i < this.scheduleRowCollections.length; i++) {
            if (i !== index) {
                this.scheduleRowCollections[i].selected = false;
            } else {
                this.scheduleRowCollections[i].selected = true;
                this._selectedScheduleRowCollection = this.scheduleRowCollections[i];
            }
        }
    }
    public clearSchedules(keepSavedSchedule: boolean = true): void {
        if (keepSavedSchedule) {
            const schedulesToRemove = this.scheduleRowCollections.where(s => s.isSaved === false);
            schedulesToRemove.forEach(s => this.scheduleRowCollections.remove(s));
        } else {
            this.scheduleRowCollections.clear();
        }
    }

    public addSchedule(schedule: ScheduleEntity, games: ScheduleRowEntity[]): void {
        this._scheduleEntity = schedule;
        const vm = new ScheduleRowCollection();
        vm.games = games;
        vm.penalty = Penalty.calculate(games, this.serie, this.teamSettings);
        vm.selected = this.scheduleRowCollections.length === 0;
        this.scheduleRowCollections.unshift(vm);
        this._selectedScheduleRowCollection = vm;
    }
    public addSchedulerResponse(schedule: SchedulerResponseEntity): void {
        const vm = new ScheduleRowCollection();
        vm.games = schedule.games;
        vm.penalty = Penalty.calculate(schedule.games, this.serie, this.teamSettings);
        vm.selected = this.scheduleRowCollections.length === 0;
        this.scheduleRowCollections.unshift(vm);
    }


    public toEntity(): ScheduleEntity {
        return this._scheduleEntity;
    }



    // private _updatePenalty(message: ScheduleUpdatedMessage): void {
    //   // TODO since editing not bound to scheduelRowCollection this to not Worker, move to genereate schedule (or does it work???)
    //   for (const schedule of this.scheduleRowCollections) {
    //     schedule.penalty = Penalty.calculate(schedule.games, this.serie, this.teamSettings);
    //   }
    // }
}
